export const APP_NAME = "Cinematics";
